import { Input } from '@/components/ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Button } from '@/components/ui/button';
import { Search, Download, RefreshCw } from 'lucide-react';

interface MessageFiltersProps {
  searchTerm: string;
  onSearchChange: (value: string) => void;
  statusFilter: string;
  onStatusChange: (value: string) => void;
  serviceFilter: string;
  onServiceChange: (value: string) => void;
  onExport: () => void;
  onRefresh: () => void;
  isRefreshing: boolean;
}

const MessageFilters = ({
  searchTerm,
  onSearchChange,
  statusFilter,
  onStatusChange,
  serviceFilter,
  onServiceChange,
  onExport,
  onRefresh,
  isRefreshing
}: MessageFiltersProps) => {
  return (
    <div className="flex flex-col md:flex-row gap-4 mb-6">
      <div className="relative flex-1">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground" />
        <Input
          placeholder="Search messages..."
          value={searchTerm}
          onChange={(e) => onSearchChange(e.target.value)}
          className="pl-10 glass border-surface-variant focus:border-cyber-blue"
        />
      </div>
      
      <Select value={statusFilter} onValueChange={onStatusChange}>
        <SelectTrigger className="w-full md:w-[180px] glass border-surface-variant">
          <SelectValue placeholder="Status" />
        </SelectTrigger>
        <SelectContent className="glass bg-background/95 backdrop-blur-md border-surface-variant">
          <SelectItem value="all">All Status</SelectItem>
          <SelectItem value="unread">Unread</SelectItem>
          <SelectItem value="read">Read</SelectItem>
        </SelectContent>
      </Select>

      <Select value={serviceFilter} onValueChange={onServiceChange}>
        <SelectTrigger className="w-full md:w-[180px] glass border-surface-variant">
          <SelectValue placeholder="Service Type" />
        </SelectTrigger>
        <SelectContent className="glass bg-background/95 backdrop-blur-md border-surface-variant">
          <SelectItem value="all">All Services</SelectItem>
          <SelectItem value="web-development">Web Development</SelectItem>
          <SelectItem value="software-engineering">Software Engineering</SelectItem>
          <SelectItem value="custom-keyboards">Custom Keyboards</SelectItem>
          <SelectItem value="3d-printing">3D Printing</SelectItem>
          <SelectItem value="consultation">Consultation</SelectItem>
          <SelectItem value="other">Other</SelectItem>
        </SelectContent>
      </Select>

      <div className="flex gap-2">
        <Button
          variant="outline"
          size="icon"
          onClick={onRefresh}
          disabled={isRefreshing}
          className="glass border-cyber-blue text-cyber-blue hover:bg-cyber-blue/10"
        >
          <RefreshCw className={`w-4 h-4 ${isRefreshing ? 'animate-spin' : ''}`} />
        </Button>
        
        <Button
          variant="outline"
          onClick={onExport}
          className="glass border-cyber-green text-cyber-green hover:bg-cyber-green/10"
        >
          <Download className="w-4 h-4 mr-2" />
          Export CSV
        </Button>
      </div>
    </div>
  );
};

export default MessageFilters;
